export default __webpack_public_path__ + "static/infographic-970023c7548332afe91548a08b24715d.png";